
export default function notExpired(
  timeStamp: Date | null,
  intervalSeconds: number,
) {
  if (!timeStamp) return true;
  const timeNow = new Date();
  // @ts-ignore
  return Math.abs(timeNow - timeStamp) / 1000 > intervalSeconds;
}
